import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default Vue.extend({
    components: {
      Confirm,
    },

    data: () => ({
      jobs : [],
      dataLoading : false,
      confirmRes : false,
      show: true,
      sortBy_arr : ['Newer Date', 'Older Date'],
      sortByValue : '',
      newArray : [],
      searchValue:''
    }),

    created(){
      this.all_draft_job();
    },

    methods:{
      async all_draft_job(){
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        this.dataLoading = true;
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let resp = await this.$http.get('job/fetchAllDraftJobsByRecruiter/'+userId, auth)
          console.log(resp);
          if (resp.status === 200 && resp.data.message === "Jobs found"){
            this.jobs = resp.data.jobs;
            for (let i = 0; i < this.jobs.length; i++) {
              if (this.jobs[i].exam_dates.length>0) {
                for (let j = 0; j < this.jobs[i].exam_dates.length; j++) {
                  var day = moment.unix(this.jobs[i].exam_dates[j]);
                  this.jobs[i].exam_dates[j] = day.format('MMMM Do YYYY, h:mm a')
                }
              }
            }
            this.newArray = this.jobs;
          }
          this.dataLoading = false;
        }
      },

      backPage() {
        window.history.back()
      },

      edit(jid){
        this.$router.push({ name: 'update_job-application', params: { id: jid } })
      },

      async job_delete(id){
        try {
          //  await this.alertMsg('Remove Job','info','Are you sure?',id)
           this.$swal({
            title: 'Remove Application',
            text: 'Are you sure?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText:'Cancel',
            customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_draft(id);
          }
         
        })

        }catch(error){}
      },

    
      async delete_draft(id){
        let token = localStorage.getItem("jwt");
        let userId = localStorage.getItem("userId");
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let res = await this.$http.post('/job/removeJob',{
            job_id: id,
            user_id: userId
          },auth);
          console.log("response checked",res);
          if (res.status === 200 && res.data.message) {
            // this.snackbar = true;
            // this.showMessage = 'Removed Successfully.'
            console.log("deleted",res);
            this.all_draft_job();
          
          } else {
            this.snackbar = true;
            this.showMessage = 'Something wrong! Please try again.'
          }
        
      }
      },

      onChange(){
        let changeArr = this.jobs.slice(0);
        if (this.sortByValue != 'Newer Date'){
          this.jobs = changeArr.reverse();
        } else {
          this.jobs= this.newArray;
        }        
      },

      up(){
        let changeArr = this.newArray.slice(0);
        if (this.searchValue.length>2) {
          const filteredData = changeArr.filter(value => {
            const searchStr = this.searchValue.toLowerCase();
            const nameMatches = value.job_title.toLowerCase().includes(searchStr);
            return nameMatches ;
          });
          this.jobs= filteredData;
          console.log('filteredData',this.jobs);
        }
        else{
          this.jobs= this.newArray;
        }        
      }
    }
  })